import { api } from '@/services';
import type { ExportarDocumentosTurboPayload, ExportarDocumentosTurboResponse } from '../types';

export const LIMITE_DA_EXPORTACAO_MS = 10 * 60 * 1000;

export async function exportarDocumentosTurboApi(
  payload: ExportarDocumentosTurboPayload
): Promise<ExportarDocumentosTurboResponse> {
  return api.post<ExportarDocumentosTurboResponse, ExportarDocumentosTurboPayload>(
    'Documento/ExportarDocumentosTurbo',
    payload,
    { timeoutMs: LIMITE_DA_EXPORTACAO_MS }
  );
}
